import { render } from "./SampleFields.vue?vue&type=template&id=1bfb8950"
import script from "./SampleFields.vue?vue&type=script&lang=js"
export * from "./SampleFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__